import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SalesloftApiService {
    constructor(private readonly baseApiService: BaseApiService) {}

    authenticate(code: string): Observable<any> {
        return this.baseApiService.post('salesloft/authenticate', {
            code: code,
            redirect_uri: environment.salesloft.redirectUrl
        });
    }

    saveSettings(payload: any): Observable<any> {
        return this.baseApiService.post('salesloft/settings', payload);
    }

    setCadence() {
        return this.baseApiService.get('salesloft/cadences');
    }

    getTags(): Observable<any> {
        return this.baseApiService.get('salesloft/tags');
    }

    refreshToken(): any {
        return this.baseApiService.post('salesloft/refreshToken');
    }

    validateDuplicates(ids) {
        return this.baseApiService.post('service/contactcloud/salesloft/duplicate', { ids });
    }

    exportV2Batch(toBeExported, duplicateResolution, selectedCadence, available_tags) {
        return this.baseApiService.post('service/contactcloud/salesloft/exportV2', {
            ids: toBeExported,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            cadences: selectedCadence,
            tags: available_tags
        });
    }

    exportV2(toBeExported, duplicateResolution, available_tags) {
        const data = {
            ids: toBeExported,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            tags: available_tags
        }
        return this.baseApiService.post(`service/contactcloud/salesloft/exportV2`, data);
    }

    getSettings(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/salesloft/settings');
    }

    saveSettingsData(payload: any): Observable<any> {
        return this.baseApiService.put('service/contactcloud/salesloft/settings', payload);
    }
}
